var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showProps&&_vm.shwoBox)?_c('v-touch',{staticClass:"yxybox",on:{"tap":function($event){return _vm.goBack()}}},[_c('v-touch',{staticClass:"closeBoxe",on:{"tap":function($event){return _vm.close()}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/yxyBox.vue?vue&type=template&id=07f0793d&
// module id = null
// module chunks = 